import {
  Box,
  CardContent,
  Card,
  Chip,
  FormControl,
  FormHelperText,
  Grid,
  TextField,
  TableBody,
  TableHead,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Tooltip,
  IconButton,
  DialogContentText,
  Typography,
  Checkbox,
  Pagination,
  CircularProgress,
} from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import React, {
  useEffect,
  // useMemo,
  useState,
} from "react";
import {
  CustomButton,
  StyledCard,
  StyledOutlineButton,
  VendorCardLabel,
} from "../../vendorRegistration/components/StepMain";
import {
  Super,
  VendorCardSubTitle,
} from "../../vendorRegistration/components/steps/cardTrial";
import { VendorCardTitle } from "../../vendorRegistration/components/steps/vendorReg";
import { useForm } from "react-hook-form";
import { styled } from "@mui/system";

import {
  CustomTableContainer,
  TableContentFont,
  TableHeaderFont,
} from "../../../styles/tableContent.style";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { Delete, RemoveRedEye } from "@mui/icons-material";
import { asnInitialData, createAsn } from "../redux/asnModuleSlice";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { history } from "../../../app/history";
import { LoadingButton } from "@mui/lab";

const Input = styled("input")({
  display: "none",
});

function NewAsnModuleContent() {
  const dispatch = useDispatch();
  const params = useParams();

  const {
    asnInitialData: data,
    loading,
    create_asn_loading,
  } = useSelector((state) => state.asnModule);

  const [addUploadDocumentModalOpen, setAddUploadDocumentModalOpen] =
    useState(false);
  const [documentItemDetails, setDocumentItemDetails] = useState(null);
  const [documentsList, setDocumentsList] = useState([]);
  const [documents, setDocuments] = useState("");
  const [deleteDocModal, setDeleteDocModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedItemDetails, setSelectedItemDetails] = useState([]);
  const [viewModal, setViewModal] = useState(false);
  const [viewItemDetails, setViewItemDetails] = useState(null);
  const [inputValue, setInputValue] = React.useState(null);
  const [quantityErr, setQuantityErr] = useState(null);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const order_id = params.orderid;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const documentListColumns = [
    { key: "srNo", label: "Sr. No." },
    { key: "doc_title", label: "Document Title" },
    { key: "name", label: "Documents" },
  ];

  const itemColumns = [
    { key: "srNo", label: "Sr. No." },
    { key: "MaterialCode", label: "Item Code" },
    { key: "Description", label: "Item Name" },
    { key: "quantity", label: "PO Quantity" },
    { key: "remaining_quentity", label: "Remaining Quantity" },
    { key: "asn_quantity", label: "ASN Quantity" },
    { key: "uom", label: "UOM" },
    // { key: "unit_price", label: "Rate" },
    { key: "action", label: "Action" },
  ];
  const viewItemFields = [
    { label: "ITEM CODE", key: "MaterialCode" },
    { label: "ITEM NAME", key: "Description" },
    { label: "QUANTITY", key: "quantity" },
    { label: "UOM", key: "uom" },
    { label: "ITEM DESCRIPTION", key: "item_description" },
    // { label: "RATE", key: "unit_price" },
    // { label: "DISCOUNT IN %", key: "discount" },
    { label: "LOCATION", key: "location" },
    // { label: "GST TYPE", key: "gst_type" },
    // { label: "GST IN %", key: "gst_per" },
    // { label: "ITEM TOTAL AMOUNT", key: "unit_total_price" },
    { label: "DATE OF DELIVERY", key: "delievery_date" },
  ];
  const handleSelectAll = () => {
    const currentPageItems =
      data?.item?.data?.filter((item) => item?.isDisable !== true) || [];
    const currentPageIds = currentPageItems?.map((item) => item.id);

    const isAllSelected = currentPageIds.every((id) =>
      selectedItems?.includes(id)
    );

    if (isAllSelected) {
      const updatedSelectedItems = selectedItems?.filter(
        (id) => !currentPageIds.includes(id)
      );
      const updatedDetails = selectedItemDetails?.filter(
        (item) => !currentPageIds.includes(item.id)
      );
      setSelectedItems(updatedSelectedItems);
      setSelectedItemDetails(updatedDetails);
    } else {
      const newSelectedIds = [
        ...selectedItems,
        ...currentPageIds.filter((id) => !selectedItems?.includes(id)),
      ];
      const newSelectedDetails = [
        ...selectedItemDetails,
        ...currentPageItems.filter((item) => !selectedItems?.includes(item.id)),
      ];
      setSelectedItems(newSelectedIds);
      setSelectedItemDetails(newSelectedDetails);
    }
  };

  const handleCheckboxChange = (code) => {
    const item = data?.item?.data?.find((item) => item?.id === code);

    setSelectedItems((prevSelected) => {
      const isSelected = prevSelected.includes(code);

      if (isSelected) {
        setSelectedItemDetails((prevDetails) =>
          prevDetails.filter((i) => i.id !== code)
        );
        return prevSelected.filter((id) => id !== code);
      } else {
        setSelectedItemDetails((prevDetails) => [...prevDetails, item]);
        return [...prevSelected, code];
      }
    });
  };
  const handleViewModalOpen = (itemID) => {
    setViewModal(true);
    if (itemID) {
      const item = data?.item?.data?.find(
        (item) => item?.MaterialMaster?.MaterialCode === itemID
      );
      setViewItemDetails(item);
    }
  };
  const handleViewModalClose = () => {
    setViewModal(false);
    setViewItemDetails(null);
  };
  const handleQuantityChange = (rowIndex, field, value, id) => {
    const asn_quantity = Number(value) || 0;
    const quantity = data?.item?.data?.find(
      (item) => item?.id === id
    ).remaining_quentity;
    // Number(data?.item?.data?.[rowIndex]?.remaining_quentity) || 0;

    const newRqty = quantity - asn_quantity;

    if (Number(newRqty) < 0) {
      setQuantityErr((prev) => ({
        ...prev,
        [id]: "quantity should not exceeds remaining quantity",
      }));
      return null;
    } else {
      setQuantityErr((prev) => ({
        ...prev,
        [id]: null,
      }));
    }

    setInputValue((prev) => ({
      ...prev,
      [id]: {
        ...prev?.[id],
        [field]: value,
        remaining_quentity: newRqty,
      },
    }));
  };
  const handleClose = (closeType) => {
    if (closeType === "inClose" || closeType === "outClose") {
      const userConfirmed = window.confirm(
        "Your entered item data will be lost. Do you want to close the dialog box?"
      );
      if (userConfirmed) {
        setDocumentItemDetails(null);
        setDocuments("");
      }
    }
    if (closeType === "uploadDocument") {
      setAddUploadDocumentModalOpen(false);
      setDocumentItemDetails(null);
      setDocuments("");
    }
  };

  const handleSave = (asn_details) => {
    const apiPayload = {
      asn_number: asn_details?.asn_number,
      asn_date: asn_details?.asn_date,
      shipment_date: asn_details?.shipment_date,
      estimeted_arrival_date: asn_details?.estimated_arrival_date,
      order_number: asn_details?.po_number,
      carrier_details: {
        name: asn_details?.carrier_name,
        tracking_number: asn_details?.tracking_number,
        shopping_method: asn_details?.shipping_method,
      },
      contact_person: {
        contact_person_name: asn_details?.person_name,
        contact_person_email: asn_details?.contact_number,
      },
      items: selectedItemDetails
        ?.map((sub_item, index) => ({
          item_id: sub_item?.id,
          quantity: inputValue?.[sub_item?.id]?.asn_quantity,
        }))
        ?.filter((item) => selectedItems?.includes(item?.item_id)),
      documents: documentsList?.map((doc) => ({
        document_title: doc?.doc_title,
        docs_name: doc?.file?.name,
      })),
    };

    var formData = new FormData();
    formData.append("data", JSON.stringify(apiPayload));
    for (let i = 0; i < documentsList?.length; i++) {
      formData.append("docs", documentsList[i]?.file);
    }
    dispatch(createAsn(formData)).then((response) => {
      if (response?.payload?.success) {
        history.push("/app/user-asns-list");
      }
    });
  };

  const handleAddUploadDocumentModal = () => {
    setAddUploadDocumentModalOpen(true);
  };
  const handleAddDocumentData = () => {
    setDocumentsList([
      ...documentsList,
      {
        ...documentItemDetails,
        file: documents,
      },
    ]);
    handleClose("uploadDocument");
  };
  const handleChange = (event, type) => {
    const { name, value } = event.target;
    if (type === "doc_title") {
      setDocumentItemDetails((prev) => {
        const updatedDetails = {
          ...prev,
          [name]: value,
        };
        return updatedDetails;
      });
    }
  };
  const handleDeleteTermsModalOpen = (itemID, type) => {
    setDeleteDocModal(type);
    if (itemID !== null || itemID !== undefined || itemID !== "") {
      setDocumentItemDetails(itemID);
    }
  };
  const handleDeleteDocModalClose = () => {
    setDeleteDocModal(false);
    setDocumentItemDetails(null);
  };
  const handleDeleteTerms = () => {
    if (deleteDocModal === "uploadDocument") {
      const updatedItems = documentsList?.filter(
        (item, index) => index !== documentItemDetails
      );
      setDocumentsList(updatedItems);
      handleDeleteDocModalClose();
    }
  };
  const handleChangeRowsPerPage = (event) => {
    setPerPage(event);
    setPage(1);
  };

  const getAsnInitialData = () => {
    dispatch(asnInitialData({ oid: order_id, page: page, per_page: perPage }));
  };

  useEffect(() => {
    getAsnInitialData();
    // eslint-disable-next-line
  }, [perPage, page]);
  return (
    <>
      <Dialog
        open={addUploadDocumentModalOpen}
        onClose={(e) => handleClose("outClose")}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {"Enter Upload Document Details"}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={6}>
            <Grid item md={4}>
              <VendorCardSubTitle>Title</VendorCardSubTitle>
              <TextField
                sx={{
                  input: {
                    fontSize: "14px",
                    fontFamily: "var(--font-family-reg)",
                  },
                }}
                placeholder="Enter Title"
                type="text"
                size="small"
                variant="standard"
                style={{ width: "100%", paddingTop: "3px" }}
                name="doc_title"
                value={documentItemDetails?.doc_title ?? ""}
                onChange={(e) => {
                  handleChange(e, "doc_title");
                }}
              />
            </Grid>
            <Grid item xs={4} sx={{ display: "flex", alignItems: "end" }}>
              {documents !== "" ? (
                <>
                  <span
                    style={{
                      color: "#4945FF",
                      fontSize: "13px",
                      fontFamily: "var(–font-family-reg)",
                    }}
                  >
                    <Chip
                      style={{
                        width: "150px",
                        color: "#4945FF",
                        // margin: "5px",
                        borderRadius: "5px",
                        border: "1px solid #D9D8FF",
                        background: "#F0F0FF",
                      }}
                      label={documents.name}
                      value={documents.name}
                      name="chips"
                    />
                    <HighlightOffIcon
                      sx={{ color: "#4945FF", paddingBottom: "2px" }}
                      fontSize="medium"
                      onClick={(e) => setDocuments("")}
                    />
                  </span>
                </>
              ) : (
                <label htmlFor="dealer">
                  <Input
                    accept="*"
                    id="dealer"
                    name="dealer"
                    onChange={(e) => setDocuments(e.target.files[0])}
                    type="file"
                  />
                  <StyledOutlineButton variant="outlined" component="span">
                    Upload
                  </StyledOutlineButton>
                  <span>{documents.name}</span>
                </label>
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={(e) => handleClose("uploadDocument")}
            variant="outlined"
            style={{
              borderColor: "var(--button-color)",
              color: "black",
            }}
            size="small"
          >
            Close
          </Button>
          <Button
            variant="contained"
            style={{
              float: "right",
              backgroundColor: "success",
              color: "white",
            }}
            onClick={handleAddDocumentData}
            autoFocus
            size="small"
          >
            {"Add"}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={deleteDocModal === "uploadDocument" ? true : false}
        onClose={handleDeleteDocModalClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Please Confirm"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to remove this document?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleDeleteDocModalClose}
            variant="outlined"
            style={{
              borderColor: "red",
              color: "black",
            }}
            size="small"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            style={{
              float: "right",
              // backgroundColor: "var(--button-color)",
              color: "white",
            }}
            color="error"
            onClick={handleDeleteTerms}
            autoFocus
            size="small"
          >
            Remove
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={viewModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="lg"
        fullWidth
        onClose={handleViewModalClose}
      >
        <DialogTitle id="alert-dialog-title">
          {`Item #${viewItemDetails?.MaterialMaster?.MaterialCode}`}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Grid container spacing={4}>
              {viewItemDetails &&
                viewItemFields.map((field) => (
                  <Grid
                    item
                    xs={field?.label === "ITEM DESCRIPTION" ? 12 : 3}
                    md={field.label === "ITEM DESCRIPTION" ? 12 : 3}
                  >
                    <Typography className="label">{field.label}</Typography>
                    <VendorCardLabel>
                      {field.formatter
                        ? field.formatter(viewItemDetails[field.key])
                        : field.key === "MaterialCode" ||
                          field.key === "Description"
                        ? viewItemDetails?.MaterialMaster?.[field.key]
                        : viewItemDetails[field.key]}
                    </VendorCardLabel>
                  </Grid>
                ))}
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleViewModalClose}
            variant="outlined"
            style={{
              borderColor: "var(--button-color)",
              color: "black",
            }}
            size="small"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      {/* {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            paddingTop: "20px",
            paddingBottom: "20px",
          }}
        >
          <CircularProgress sx={{ display: "block", margin: "0 auto" }} />
        </Box>
      ) : ( */}
      <form onSubmit={handleSubmit(handleSave)}>
        <StyledCard>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item md={6}>
                <VendorCardTitle style={{ paddingBottom: "0" }}>
                  Create New Advanced Shipping Notice
                </VendorCardTitle>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item md={8}>
                <VendorCardSubTitle style={{ marginTop: "0" }}>
                  Select the lot and enter ASN details
                </VendorCardSubTitle>
              </Grid>
            </Grid>
            <br />
            <Grid container spacing={2}>
              <Grid item md={6}>
                <FormControl variant="standard" style={{ width: "100%" }}>
                  <VendorCardLabel>Purchase Order Number</VendorCardLabel>
                  <TextField
                    sx={{
                      input: {
                        fontSize: "14px",
                        fontFamily: "var(--font-family-reg)",
                      },
                    }}
                    placeholder="Purchase Order Number "
                    size="small"
                    variant="standard"
                    style={{ width: "100%", paddingTop: "3px" }}
                    disabled
                    value={data?.order_number}
                    name="po_number "
                    {...register("po_number", {
                      required: "Please Purchase Order Number ",
                      value: data?.order_number,
                    })}
                    error={Boolean(errors?.po_number)}
                    helperText={errors?.po_number?.message}
                  />
                  <FormHelperText></FormHelperText>
                </FormControl>
              </Grid>
              <Grid item md={6}>
                <VendorCardLabel>
                  ASN number<Super>*</Super>
                </VendorCardLabel>
                <TextField
                  sx={{
                    input: {
                      fontSize: "14px",
                      fontFamily: "var(--font-family-reg)",
                    },
                  }}
                  placeholder="Enter ASN number"
                  size="small"
                  variant="standard"
                  style={{ width: "100%", paddingTop: "3px" }}
                  name="asn_number"
                  {...register("asn_number", {
                    required: "Please Enter ASN Number",
                    value: data?.asn_unique_number,
                  })}
                  value={data?.asn_unique_number}
                  error={Boolean(errors?.asn_number)}
                  helperText={errors?.asn_number?.message}
                  disabled
                />
              </Grid>
              <Grid item md={6}>
                <FormControl variant="standard" style={{ width: "100%" }}>
                  <VendorCardLabel>
                    ASN Date<Super>*</Super>
                  </VendorCardLabel>
                  <TextField
                    sx={{
                      input: {
                        fontSize: "14px",
                        fontFamily: "var(--font-family-reg)",
                      },
                    }}
                    InputProps={{
                      disableUnderline: false,
                      disableInjectingGlobalStyles: true,
                    }}
                    InputLabelProps={{
                      disableAnimation: true,
                      disableInjectingGlobalStyles: true,
                    }}
                    size="small"
                    variant="standard"
                    type="date"
                    style={{
                      width: "100%",
                      paddingTop: "3px",
                      borderBottom: errors?.asn_date
                        ? "0"
                        : "1px solid lightgray",
                    }}
                    name="asn_date"
                    placeholder="Select ASN Date"
                    {...register("asn_date", {
                      required: "Please Select ASN Date",
                    })}
                    // value={datevalue || ""}
                    // onChange={(e) => handleinvdate(e)}
                    // inputProps={{
                    //   min: new Date(date).toISOString().split("T")[0], // Set the minimum date
                    // }}
                    error={Boolean(errors?.asn_date)}
                    helperText={errors?.asn_date?.message}
                  />
                </FormControl>
              </Grid>
              <Grid item md={6}>
                <FormControl variant="standard" style={{ width: "100%" }}>
                  <VendorCardLabel>
                    Shipment Date<Super>*</Super>
                  </VendorCardLabel>
                  <TextField
                    sx={{
                      input: {
                        fontSize: "14px",
                        fontFamily: "var(--font-family-reg)",
                      },
                    }}
                    InputProps={{
                      disableUnderline: false,
                      disableInjectingGlobalStyles: true,
                    }}
                    InputLabelProps={{
                      disableAnimation: true,
                      disableInjectingGlobalStyles: true,
                    }}
                    size="small"
                    variant="standard"
                    type="date"
                    style={{
                      width: "100%",
                      paddingTop: "3px",
                      borderBottom: errors?.shipment_date
                        ? "0"
                        : "1px solid lightgray",
                    }}
                    name="shipment_date"
                    placeholder="Select Shipment Date"
                    {...register("shipment_date", {
                      required: "Please Select Shipment Date",
                    })}
                    // value={datevalue || ""}
                    // onChange={(e) => handleinvdate(e)}
                    // inputProps={{
                    //   min: new Date(date).toISOString().split("T")[0], // Set the minimum date
                    // }}
                    error={Boolean(errors?.shipment_date)}
                    helperText={errors?.shipment_date?.message}
                  />
                </FormControl>
              </Grid>
              <Grid item md={6}>
                <FormControl variant="standard" style={{ width: "100%" }}>
                  <VendorCardLabel>
                    Estimated Arrival Date<Super>*</Super>
                  </VendorCardLabel>
                  <TextField
                    sx={{
                      input: {
                        fontSize: "14px",
                        fontFamily: "var(--font-family-reg)",
                      },
                    }}
                    InputProps={{
                      disableUnderline: false,
                      disableInjectingGlobalStyles: true,
                    }}
                    InputLabelProps={{
                      disableAnimation: true,
                      disableInjectingGlobalStyles: true,
                    }}
                    size="small"
                    variant="standard"
                    type="date"
                    style={{
                      width: "100%",
                      paddingTop: "3px",
                      borderBottom: errors?.estimated_arrival_date
                        ? "0"
                        : "1px solid lightgray",
                    }}
                    name="estimated_arrival_date"
                    placeholder="Select Estimated Arrival Date"
                    {...register("estimated_arrival_date", {
                      required: "Please Select Estimated Arrival Date",
                    })}
                    // value={datevalue || ""}
                    // onChange={(e) => handleinvdate(e)}
                    // inputProps={{
                    //   min: new Date(date).toISOString().split("T")[0], // Set the minimum date
                    // }}
                    error={Boolean(errors?.estimated_arrival_date)}
                    helperText={errors?.estimated_arrival_date?.message}
                  />
                </FormControl>
              </Grid>
            </Grid>
            <br />
            <br />
            <VendorCardTitle style={{ paddingBottom: "20px" }}>
              Carrier Details
            </VendorCardTitle>
            <Grid container spacing={2}>
              <Grid item md={6}>
                <FormControl variant="standard" style={{ width: "100%" }}>
                  <VendorCardLabel>Carrier Name<Super>*</Super></VendorCardLabel>
                  <TextField
                    sx={{
                      input: {
                        fontSize: "14px",
                        fontFamily: "var(--font-family-reg)",
                      },
                    }}
                    placeholder="Enter Carrier Name"
                    size="small"
                    variant="standard"
                    style={{ width: "100%", paddingTop: "3px" }}
                    name="carrier_name "
                    {...register("carrier_name", {
                      required: "Please Enter Carrier Name",
                    })}
                    error={Boolean(errors?.carrier_name)}
                    helperText={errors?.carrier_name?.message}
                  />
                </FormControl>
              </Grid>
              <Grid item md={6}>
                <FormControl variant="standard" style={{ width: "100%" }}>
                  <VendorCardLabel>Tracking Number<Super>*</Super></VendorCardLabel>
                  <TextField
                    sx={{
                      input: {
                        fontSize: "14px",
                        fontFamily: "var(--font-family-reg)",
                      },
                    }}
                    placeholder="Enter Tracking Number"
                    size="small"
                    variant="standard"
                    style={{ width: "100%", paddingTop: "3px" }}
                    type="text"
                    name="tracking_number "
                    {...register("tracking_number", {
                      required: "Please Enter Tracking Number",
                    })}
                    error={Boolean(errors?.tracking_number)}
                    helperText={errors?.tracking_number?.message}
                  />
                </FormControl>
              </Grid>
              <Grid item md={6}>
                <FormControl variant="standard" style={{ width: "100%" }}>
                  <VendorCardLabel>Shipping Method<Super>*</Super></VendorCardLabel>
                  <TextField
                    sx={{
                      input: {
                        fontSize: "14px",
                        fontFamily: "var(--font-family-reg)",
                      },
                    }}
                    placeholder="Enter Shipping Method"
                    size="small"
                    variant="standard"
                    style={{ width: "100%", paddingTop: "3px" }}
                    name="shipping_method "
                    {...register("shipping_method", {
                      required: "Please Enter Shipping Method",
                    })}
                    error={Boolean(errors?.shipping_method)}
                    helperText={errors?.shipping_method?.message}
                  />
                </FormControl>
              </Grid>
            </Grid>
            <br />
            <br />
            <VendorCardTitle style={{ paddingBottom: "20px" }}>
              Contact Person Details{" "}
            </VendorCardTitle>
            <Grid container spacing={2}>
              <Grid item md={6}>
                <FormControl variant="standard" style={{ width: "100%" }}>
                  <VendorCardLabel>Person Name<Super>*</Super></VendorCardLabel>
                  <TextField
                    sx={{
                      input: {
                        fontSize: "14px",
                        fontFamily: "var(--font-family-reg)",
                      },
                    }}
                    placeholder="Enter Person Name"
                    size="small"
                    variant="standard"
                    style={{ width: "100%", paddingTop: "3px" }}
                    name="person_name "
                    {...register("person_name", {
                      required: "Please Enter Person Name",
                    })}
                    error={Boolean(errors?.person_name)}
                    helperText={errors?.person_name?.message}
                  />
                </FormControl>
              </Grid>
              <Grid item md={6}>
                <FormControl variant="standard" style={{ width: "100%" }}>
                  <VendorCardLabel>Contact Number<Super>*</Super></VendorCardLabel>
                  <TextField
                    sx={{
                      input: {
                        fontSize: "14px",
                        fontFamily: "var(--font-family-reg)",
                      },
                    }}
                    placeholder="Enter Contact Number"
                    size="small"
                    variant="standard"
                    style={{ width: "100%", paddingTop: "3px" }}
                    type="number"
                    name="contact_number"
                    {...register("contact_number", {
                      required: "Please Enter Contact Number",
                      validate: (value) =>
                        parseFloat(value) >= 0 ||
                        "Contact Number cannot be negative",
                    })}
                    error={Boolean(errors?.contact_number)}
                    helperText={errors?.contact_number?.message}
                  />
                </FormControl>
              </Grid>
            </Grid>
            <br />
            <br />
            <VendorCardTitle style={{ paddingBottom: "20px" }}>
              Items Details{" "}
            </VendorCardTitle>
            {data?.item?.data?.length ? (
              <CustomTableContainer component={Card}>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow
                      style={{
                        backgroundColor: "#e1ebfa",
                      }}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          indeterminate={
                            data?.item?.data?.some((item) =>
                              selectedItems?.includes(item.id)
                            ) &&
                            !data?.item?.data?.every((item) =>
                              selectedItems?.includes(item.id)
                            )
                          }
                          checked={
                            data?.item?.data?.length > 0 &&
                            data?.item?.data?.every((item) =>
                              selectedItems?.includes(item.id)
                            )
                          }
                          onChange={handleSelectAll}
                        />
                      </TableCell>
                      {itemColumns.map((column, index) => (
                        <TableCell
                          key={index}
                          style={{ fontWeight: "bold", fontSize: "14px" }}
                        >
                          {column?.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data?.item?.data?.map((item, index) => (
                      <TableRow
                        key={index}
                        style={{
                          backgroundColor: "#fafcff",
                        }}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={selectedItems.includes(item?.id)}
                            onChange={() => handleCheckboxChange(item?.id)}
                            disabled={item?.isDisable}
                          />
                        </TableCell>
                        {itemColumns.map((column) => (
                          <>
                            <TableCell
                              key={column.key}
                              style={{
                                fontFamily: "var(--font-family-reg)",
                                fontSize: "12px",
                                textAlign: column.align || "left",
                                color:
                                  column?.key === "MaterialCode"
                                    ? "#0d6efd"
                                    : "none",
                              }}
                            >
                              {column?.key === "srNo" ? (
                                index + 1
                              ) : column?.key === "MaterialCode" ? (
                                item?.MaterialMaster?.[column?.key]
                              ) : column?.key === "Description" ? (
                                item?.MaterialMaster?.[column?.key]
                              ) : column?.key === "asn_quantity" ? (
                                <TableContentFont>
                                  <TextField
                                    sx={{
                                      input: {
                                        fontSize: "14px",
                                        fontFamily: "var(--font-family-reg)",
                                      },
                                    }}
                                    placeholder="Enter ASN Quantity"
                                    size="small"
                                    type="number"
                                    variant="outlined"
                                    style={{
                                      width: "100%",
                                      paddingTop: "3px",
                                    }}
                                    value={
                                      inputValue?.[item?.id]?.asn_quantity || ""
                                    }
                                    required={selectedItems?.includes(item?.id)}
                                    name="asn_quantity"
                                    onChange={(e) => {
                                      const inputValue = e.target.value;
                                      const value =
                                        inputValue === ""
                                          ? ""
                                          : Math.max(0, inputValue);
                                      handleQuantityChange(
                                        index,
                                        "asn_quantity",
                                        value,
                                        item?.id
                                      );
                                    }}
                                    error={
                                      quantityErr?.[item?.id] ? true : false
                                    }
                                    helperText={quantityErr?.[item?.id]}
                                    //   value={""}
                                  />
                                </TableContentFont>
                              ) : column?.key === "remaining_quentity" ? (
                                inputValue?.[item?.id]?.remaining_quentity ??
                                item[column?.key]
                              ) : column?.key === "action" ? (
                                <Tooltip title="View Item">
                                  <IconButton aria-label="view">
                                    <RemoveRedEye
                                      style={{
                                        fill: "royalblue",
                                        height: "18px",
                                        width: "18px",
                                      }}
                                      onClick={() =>
                                        handleViewModalOpen(
                                          item?.MaterialMaster?.["MaterialCode"]
                                        )
                                      }
                                    />
                                  </IconButton>
                                </Tooltip>
                              ) : item[column?.key] ? (
                                item[column?.key]
                              ) : (
                                "-"
                              )}
                            </TableCell>
                          </>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <Grid
                  container
                  className="d-flex flex-row align-items-center justify-content-between w-100 px-3 text-muted"
                  sx={{ height: "8vh", borderTop: "1px solid lightgray" }}
                >
                  <Grid className="d-flex align-items-center gap-2">
                    <span>Rows per page: </span>
                    <select
                      value={perPage}
                      onChange={(e) => handleChangeRowsPerPage(e.target.value)}
                    >
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>
                  </Grid>
                  <Pagination
                    sx={{
                      width: "max-content",
                    }}
                    color="primary"
                    variant="text"
                    onChange={(_, newValue) => setPage(newValue)}
                    count={data?.item?.pagination?.total_page}
                    page={page}
                    shape="rounded"
                    showFirstButton
                    showLastButton
                  />
                </Grid>
              </CustomTableContainer>
            ) : (
              <Typography className="label">
                No item added yet. Start by adding an item.
              </Typography>
            )}
          </CardContent>
        </StyledCard>
        <StyledCard>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item md={6}>
                <VendorCardTitle>
                  Upload Document<Super>*</Super>
                </VendorCardTitle>
              </Grid>
              <Grid item md={6} style={{ textAlign: "right" }}>
                <Tooltip title={"Add Upload Document"}>
                  <CustomButton
                    size="small"
                    color="primary"
                    variant="outlined"
                    onClick={handleAddUploadDocumentModal}
                    className="invoiceErrbutn"
                    style={{ marginTop: "10px " }}
                  >
                    Add Upload Document
                  </CustomButton>
                </Tooltip>
              </Grid>
            </Grid>

            {documentsList?.length ? (
              <CustomTableContainer component={Card}>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow
                      style={{
                        backgroundColor: "#e1ebfa",
                      }}
                    >
                      {documentListColumns.map((column, index) => (
                        <TableCell
                          key={index}
                          style={{ fontWeight: "bold", fontSize: "14px" }}
                        >
                          {column?.label}
                        </TableCell>
                      ))}
                      <TableCell>
                        <TableHeaderFont>Action</TableHeaderFont>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {documentsList.map((item, index) => (
                      <TableRow
                        key={index}
                        style={{
                          backgroundColor: "#fafcff",
                        }}
                      >
                        {documentListColumns.map((column) => (
                          <>
                            <TableCell
                              key={column.key}
                              style={{
                                fontFamily: "var(--font-family-reg)",
                                fontSize: "12px",
                                textAlign: column.align || "left",
                              }}
                            >
                              {column?.key === "srNo"
                                ? index + 1
                                : column.key === "name"
                                ? item?.file?.[column?.key]
                                : item[column?.key]
                                ? item[column?.key]
                                : "-"}
                            </TableCell>
                          </>
                        ))}
                        <TableCell
                          sx={{
                            display: "flex",
                            gap: 1,
                          }}
                        >
                          <Tooltip title="Delete Item">
                            <IconButton aria-label="delete">
                              <Delete
                                style={{
                                  fill: "royalblue",
                                  height: "18px",
                                  width: "18px",
                                }}
                                onClick={() =>
                                  handleDeleteTermsModalOpen(
                                    index,
                                    "uploadDocument"
                                  )
                                }
                              />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </CustomTableContainer>
            ) : (
              <Typography className="label">
                No document added yet. Start by adding an document.
              </Typography>
            )}
          </CardContent>
        </StyledCard>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            pt: 2,
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ flex: "1 1 auto" }} />
          <LoadingButton
            sx={{
              textTransform: "none",
              background: "var(--button-color)",
              width: "200px",
              height: "40px",
            }}
            color="success"
            variant="contained"
            type="submit"
            disabled={
              selectedItems?.length <= 0 ||
              create_asn_loading ||
              !documentsList.length
            }
            loading={create_asn_loading}
          >
            Submit
          </LoadingButton>
        </Box>
      </form>
      {/* )} */}
    </>
  );
}

export default NewAsnModuleContent;
